module.exports = __webpack_public_path__ + "static/img/WMP909-PF_Ab.6149b6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WMP909-PF_Ab.jpg
// module id = zzZ0
// module chunks = 0